import request from '@/http/request'

export const unbindByCarton = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/unbindingByCarton`,
    {},
    { params, nfc: true, headers: queryHeader }
  )
}
export const unbindByPiece = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/unbindingByPiece`, params, {
    nfc: true,
    headers: queryHeader
  })
}
export const getSkuByPiece = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/getSkuByPiece`, params, {
    nfc: true,
    headers: queryHeader
  })
}
export const validateOrUnbindOrderByCarton = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/validateOrUnbindOrderByCarton`,
    {},
    {
      nfc: true,
      headers: queryHeader,
      params
    }
  )
}
export const unbindingByOrder = (params, queryHeader) => {
  return request.post(
    `${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/rfid/unbindingByOrder`,
    {},
    {
      nfc: true,
      headers: queryHeader,
      params
    }
  )
}
